export const EVENT_ENDPOINTS = {
    OFF_EVT_LIST: '/lotte-duty-free/off-evt-list',
};
